import React from 'react';
import { Fragment } from 'react';
import { useContext } from 'react';
import { ContactUsDetail } from './ContactUsDetail';
import { contactUsOptions } from './Data';
import { HelpCenterContext } from './Context/HelpCenterContext';
import { HubspotProvider } from '@aaronhayes/react-use-hubspot-form';

export const ContactUsOptions = () => {
    const { state, dispatch } = useContext(HelpCenterContext)
    return (
        <Fragment>
            {
                state.showContactUsOptions &&
                <Fragment>
                    <HubspotProvider>
                        {state.showContactUsDetail && <ContactUsDetail />}
                    </HubspotProvider>
                    {!state.showContactUsDetail &&
                        <Fragment>
                            <strong className="font-size-2 py-3 d-block">Contact Us</strong>
                            <strong className="font-size-1 mt-4">How we can help?</strong>
                            {contactUsOptions.map(item => (
                                <div className="my-4 font-size-1 contact-us-options" onClick={() => dispatch({ type: "TOGGLE_CONTACT_DETAIL", payload: item.text })}><i className={item.icon + " me-3"}></i>{item.text}</div>
                            ))}
                        </Fragment>
                    }
                </Fragment>
            }
        </Fragment>
    )
}